export default "__VITE_ASSET__DMMb0Gnh__"